import { MapPin, Mail, Phone } from "lucide-react";
import { useLang } from "@/LangContext";
import { CONTACT } from "@/config";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-primary text-white border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16">
        <img
          src="/logo-cozy-home.png"
          alt="Cozy Home"
          className="h-24 md:h-28 w-auto mb-14 object-contain"
          data-testid="footer-logo"
        />
        <div className="grid md:grid-cols-3 gap-10 pb-16">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-white/50 mb-4">{t.footer.tagline}</div>
            <div className="space-y-3 text-white/80">
              <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-white/70" />{t.footer.address}</div>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white transition-colors"><Mail className="w-4 h-4 text-white/70" />{CONTACT.email}</a>
              {CONTACT.phone && (
                <a href={`tel:${CONTACT.phone.replace(/\s+/g, "")}`} className="flex items-center gap-3 hover:text-white transition-colors"><Phone className="w-4 h-4 text-white/70" />{CONTACT.phone}</a>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-3 text-white/80">
            <button onClick={() => scrollTo("services")} className="text-left hover:text-white transition-colors w-fit">{t.nav.services}</button>
            <button onClick={() => scrollTo("approach")} className="text-left hover:text-white transition-colors w-fit">{t.nav.about}</button>
            <button onClick={() => scrollTo("testimonials")} className="text-left hover:text-white transition-colors w-fit">{t.nav.testimonials}</button>
            <a href="https://pulisci-facile.emergent.host" className="text-left hover:text-white transition-colors w-fit">{t.nav.book}</a>
          </div>
          <div className="md:text-right text-white/60 text-sm self-end">
            © {new Date().getFullYear()} Cozy Home. {t.footer.rights}
            <a href="/admin" data-testid="footer-admin-link" className="block mt-2 text-white/40 hover:text-white transition-colors">Admin</a>
          </div>
        </div>
        <div className="font-serif tracking-tighter leading-none text-white/95 text-[19vw] md:text-[15vw] border-t border-white/10 pt-8">
          Cozy Home<span className="text-white/60">.</span>
        </div>
      </div>
    </footer>
  );
}
